import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as BaseLink } from 'react-router-dom';

export const Wrapper = styled(Card)``;

export const Link = styled(BaseLink)`
  display: flex;
  align-items: center;
`;
